/* eslint-disable */
import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import Content from './Content';
import { useSummaryCardContext } from "./Context";

const SummaryCard = (props) => {
  const { accordionSummaryCardCollection, initializingError, isInitializing } = useSummaryCardContext();

  return (
    <DataContainer
      component={Content}
      componentProps={{
        collection: accordionSummaryCardCollection,
      }}
      loading={isInitializing}
      loadingError={initializingError}
      {...props}
    />
  );
};

export default SummaryCard;
